module.exports = __webpack_public_path__ + "img/tc.4a66d0f0.svg";